import { useState, useMemo } from "react";
import { FaMobile } from "react-icons/fa";
import CardOne from "../Components/common/CardOne";
import { Text, Card, Button } from "@nikitamallya/react-ui-components";
import reactUI from "../../src/Assets/img/reactui.png";
import Healthcare from "../../src/Assets/img/mobile/healthcare.png";
import Reaching from "../../src/Assets/img/mobile/reaching.png";

const Works = (props) => {
  // --- 1) Filters (categories) ---
  const filters = [
    {
      key: "prototypes",
      icon: <FaMobile />,
      title: "Case Studies & Prototypes",
      subTitle: "(Web & Mobile Applications)",
    },
    {
      key: "uiDev",
      icon: <FaMobile />,
      title: "UI Development",
      subTitle: "(Mobile-first Approach)",
    },
    {
      key: "other",
      icon: <FaMobile />,
      title: "Other Works",
      subTitle: "(Emailers, Branding, Assets)",
    },
  ];

  const [active, setActive] = useState("prototypes"); // default shown

  // --- 2) Cards data (memoized so it doesn't recreate each render) ---
  const allCards = useMemo(
    () => [
      {
        id: "healthcare",
        tags: ["prototypes"],
        title: "Healthcare Mobile App",
        description:
          "Application that allows users to find top doctors, pharmacy & ambulance. Features yet to be enhanced.",
        imgUrl: Healthcare,
        actions: [
          {
            title: "Figma Prototype",
            url: "https://www.figma.com/proto/EtUhniB9uGWHHDEvELJOHm/Healthcare-App?node-id=1-419&t=P7mjx6q0ZCD6uFBO-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A10",
          },
        ],
      },
      {
        id: "healthcare",
        tags: ["prototypes"],
        title: "Reaching Mobile App",
        description: "A Location Sharing Application.",
        imgUrl: Reaching,
        actions: [
          {
            title: "Figma Prototype",
            url: "https://www.figma.com/proto/IOpVtjvb8ftwE2bqSnfcZs/Reaching_Location_Sharing_App?type=design&node-id=1-2&t=RBKSGfZDC0ePcCaQ-1&scaling=scale-down&page-id=0%3A1&starting-point-node-id=1%3A2&mode=design",
          },
        ],
      },
      {
        id: "react-ui",
        tags: ["uiDev"],
        title: "React UI Components | NPM Package",
        description:
          "NPM package that lets React developers use UI components effortlessly.",
        imgUrl: reactUI,
        actions: [
          {
            title: "NPM",
            url: "https://www.npmjs.com/package/@nikitamallya/react-ui-components",
          },
          {
            title: "GitHub",
            url: "https://github.com/iamnikitamallya/react-ui-components",
          },
        ],
      },
      // ➕ Add more cards here; just tag them with: "prototypes" | "caseStudies" | "uiDev" | "other"
    ],
    []
  );

  // --- 3) Filtered list ---
  const visibleCards = useMemo(
    () => allCards.filter((c) => c.tags.includes(active)),
    [allCards, active]
  );

  return (
    <div className={`${props.mode}`}>
      {/* Filters row */}
      <div className="services pt-3">
        <div className="row">
          {filters.map((f) => (
            <div className="col-md-4 col-6" key={f.key}>
              <button
                onClick={() => setActive(f.key)}
                className={`w-100 p-0 border-0 bg-transparent`}
                style={{ cursor: "pointer" }}
                aria-pressed={active === f.key}
              >
                <CardOne
                  icon={f.icon}
                  title={f.title}
                  subTitle={f.subTitle}
                  className={active === f.key ? "is-active" : ""}
                />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Cards grid */}
      <div className="row pb-4">
        {visibleCards.map((c) => (
          <div className="col-md-6" key={c.id}>
            <Card
              title={c.title}
              description={c.description}
              imgUrl={c.imgUrl}
              align="center"
            >
              {c.actions.map((a, i) => (
                <Button key={i} title={a.title} size="sm" url={a.url} />
              ))}
            </Card>
          </div>
        ))}
        {visibleCards.length === 0 && (
          <div className="col-12 py-5 text-center">
            <p>No projects in this category yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Works;
